import classNames from "classnames";
import { Color } from "utils/theme";
import { Avatar } from "components/ui/avatar";
import { opacity } from "utils/canvas";

export const CaptainCard = ({ name, isSelected, onClick }) => {
  return (
    <button
      onClick={onClick}
      style={{
        borderColor: Color.Primary[600],
        backgroundColor: isSelected
          ? opacity(Color.Indigo[400], 0.2)
          : "transparent",
      }}
      className={classNames(
        "rounded-lg overflow-hidden text-ellipsis line-clamp-2 flex justify-start items-center w-full px-4 py-3 space-x-4",
        {
          "ring-2 ring-indigo-400": isSelected,
        }
      )}
      onPointerDown={(e) => {
        e.currentTarget.style.opacity = "0.6";
      }}
      onPointerUp={(e) => {
        e.currentTarget.style.opacity = "1";
      }}
      onPointerLeave={(e) => {
        e.currentTarget.style.opacity = "1";
      }}
    >
      <Avatar
        name={name}
        size="md"
        style={{
          backgroundColor: isSelected ? Color.Indigo[500] : Color.Primary[800],
          borderColor: isSelected ? Color.Indigo[400] : Color.Primary[700],
          borderWidth: "1px",
        }}
      />
      <p className="text-base text-left font-medium line-clamp-1 overflow-hidden">
        {name}
      </p>
    </button>
  );
};
